import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import './ImpersonationModal.css';

const ImpersonationModal = ({ 
  show, 
  onClose, 
  onConfirm, 
  user, 
  loading = false 
}) => {
  if (!user) return null;

  // Get user display name
  const getUserDisplayName = () => {
    if (user.contactName) return user.contactName;
    if (user.firstName && user.lastName) return `${user.firstName} ${user.lastName}`;
    if (user.name) return user.name;
    return user.email || user.username || 'User';
  };

  // Get user type display
  const getUserType = () => {
    if (user.isSchAdmin) return 'School Admin';
    if (user.isOrgAdmin) return 'Organization Admin';
    if (user.isAdmin) return 'Admin';
    if (user.studentCode) return 'Student';
    return 'Teacher';
  };

  // Get last login info
  const getLastLogin = () => {
    if (user.lastLogin) {
      const date = new Date(user.lastLogin);
      return date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
    }
    return 'Never';
  };

  return (
    <Modal show={show} onHide={onClose} centered className="impersonation-modal">
      <Modal.Header className="impersonation-modal-header">
        <Modal.Title className="impersonation-modal-title">
          <i className="fas fa-users impersonation-title-icon"></i>
          Impersonate User
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="impersonation-modal-body">
        {/* Warning Section */}
        <div className="impersonation-warning-box">
          <i className="fas fa-exclamation-triangle impersonation-warning-icon"></i>
          <span>Are you sure you want to impersonate this user?</span>
        </div>

        {/* User Details Section */}
        <div className="impersonation-user-details">
          <div className="impersonation-user-avatar">
            <i className="fas fa-user"></i>
          </div>
          <div className="impersonation-user-info">
            <div className="impersonation-user-name">{getUserDisplayName()}</div>
            <div className="impersonation-user-email">{user.email || user.username || 'No email'}</div>
            <div className="impersonation-user-role">{getUserType()}</div>
            <div className="impersonation-user-lastlogin">Last Login: {getLastLogin()}</div>
          </div>
        </div>

        {/* Impersonation Information Section */}
        <div className="impersonation-info-box">
          <div className="impersonation-info-item">
            <i className="fas fa-clock impersonation-info-icon clock-icon"></i>
            <span>You will be logged in as this user for up to <strong>1 hour</strong></span>
          </div>
          <div className="impersonation-info-item">
            <i className="fas fa-shield-alt impersonation-info-icon shield-icon"></i>
            <span>You can return to your admin account at any time</span>
          </div>
          <div className="impersonation-info-item">
            <i className="fas fa-eye impersonation-info-icon eye-icon"></i>
            <span>This user will not see any indication they are being impersonated</span>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="impersonation-modal-footer">
        <Button 
          variant="secondary" 
          onClick={onClose} 
          disabled={loading}
          className="impersonation-cancel-btn"
        >
          Cancel
        </Button>
        <Button 
          variant="primary" 
          onClick={onConfirm} 
          disabled={loading}
          className="impersonation-confirm-btn"
        >
          {loading ? (
            <>
              <span className="spinner-border spinner-border-sm me-2" role="status"></span>
              Impersonating...
            </>
          ) : (
            <>
              <i className="fas fa-users me-2"></i>
              Impersonate User
            </>
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ImpersonationModal;
